<template>
	<el-dialog
	  :title="title"
	  :visible.sync="showWrap"
	  :close-on-click-modal="false"
	  width="501px"
	  custom-class="dialog-style tips-dialog error"
	  :append-to-body="true"
	  >
	  <div class="cont">
	    <p v-if="!rmid">Error：</p>
	    <p v-if="rmid">Error（{{rmid}}）：</p>
		<template v-if="!showTextFlag">
		  <p>{{text1}}</p>
		</template>
		<p v-if="showTextFlag" v-html="text2"></p>
		<a href="javascript:void(0);" @click="showTextFlag=!showTextFlag">{{!showTextFlag?'详情':'收起'}}</a>
	  </div>
	  <span slot="footer" class="dialog-footer">
	    <el-button type="primary" @click="showWrap = false" class="button-sty"><i class="el-icon-check el-icon"></i>确 定</el-button>
	  </span>
	</el-dialog>
</template>

<script>
  import {
    mixins
  } from './mixins'

  export default {
    // name: 'errorMsg',
    mixins: [mixins]
  }
</script>

<style>
</style>
